export const menuItems = [
  {
    id: 1,
    label: "menuitems.menu.text",
    isTitle: true,
  },
  {
    id: 2,
    label: "Dashboard",
    icon: "bx bx-home-circle",
    link: "/dashboard",
    isShowWithoutHotel: false,
    includeProjectType: ["booking"],
  },
  {
    id: 3,
    icon: "bx bxs-inbox",
    label: "Inbox",
    link: "/inbox",
    includeProjectType: ["requests"],
  },
  {
    id: 4,
    label: "Booking List",
    icon: "bx-book",
    link: "/booking",
    isShowWithoutHotel: false,
    includeProjectType: ["booking"],
    subItems: [
      {
        id: 95,
        label: "Kiosk Booking",
        link: "/booking/kiosk",
        parentId: 4,
      },
      {
        id: 5,
        label: "Night Audit",
        link: "/booking/audit",
        parentId: 4,
      },
      {
        id: 6,
        label: "Guest List",
        link: "/guest",
        parentId: 4,
      },
      {
        id: 7,
        label: "Company List",
        link: "/Company",
        parentId: 4,
      },
      {
        id: 8,
        label: "Wakeup Call List",
        link: "/wakeup-call",
        parentId: 4,
      },
    ],
  },
  {
    id: 9,
    label: "Up Sell",
    icon: "bx bx-sort-up",
    link: "/up-sell-order",
    isShowWithoutHotel: false,
    includeProjectType: ["requests"],
    subItems: [
      {
        id: 10,
        label: "Up Sell Manage",
        link: "/up-sell",
        parentId: 9,
      },
    ],
  },
  {
    id: 11,
    label: "Maintenance",
    icon: "bx bx-user-voice",
    link: "/maintenance-requests-list",
    isShowWithoutHotel: false,
    includeProjectType: ["requests"],
    subItems: [
      {
        id: 12,
        label: "MR Category Manage",
        link: "/maintenance-request",
        parentId: 11,
      },
    ],
  },
  {
    id: 13,
    label: "Inventory",
    icon: "bx-layer",
    link: "/buildings",
    isShowWithoutHotel: false,
    includeProjectType: ["settings"],
    subItems: [
      {
        id: 14,
        label: "Building",
        link: "/buildings",
        parentId: 13,
      },
      {
        id: 15,
        label: "Floor",
        link: "/floor-plan",
        parentId: 13,
      },
      {
        id: 16,
        label: "Bed Types",
        link: "/bed-type",
        parentId: 13,
      },
      {
        id: 17,
        label: "Room Type",
        link: "/room-type",
        parentId: 13,
      },
      {
        id: 18,
        label: "Rooms",
        link: "/rooms",
        parentId: 13,
      },
      {
        id: 19,
        label: "Rooms Availability",
        link: "/rooms-availability",
        parentId: 13,
      },
      {
        id: 20,
        label: "Rate Plan",
        link: "/rate-plan",
        parentId: 13,
      },
    ],
  },
  {
    id: 21,
    label: "Kiosk Machine",
    icon: "bx bx-card",
    link: "/kiosk-machine-setting",
    isShowWithoutHotel: false,
    includeProjectType: ["kiosk", "kiosk_Admin"],
  },
  {
    id: 22,
    label: "House Keeping",
    icon: "bx-task",
    link: "/task-sheet",
    isShowWithoutHotel: false,
    includeProjectType: ["settings"],
    subItems: [
      {
        id: 23,
        label: "Task Sheet",
        link: "/task-sheet",
        parentId: 22,
      },
      {
        id: 24,
        label: "Staff Health Sheet",
        link: "/staff-health-question-sheet",
        parentId: 22,
      },
      {
        id: 25,
        label: "Mini Bar",
        link: "/mini-bar",
        parentId: 22,
      },
      {
        id: 26,
        label: "Staff Shift",
        link: "/staff-shift",
        parentId: 22,
      },
      {
        id: 27,
        label: "Meta Data Setting",
        parentId: 22,
        subItems: [
          {
            id: 28,
            label: "Check List",
            link: "/check-list",
            parentId: 27,
          },
          {
            id: 29,
            label: "Health Question",
            link: "/health-questions",
            parentId: 27,
          },
          {
            id: 30,
            label: "DND Reason",
            link: "/dnd-reason",
            parentId: 27,
          },
          {
            id: 31,
            label: "Discrepancy Reason",
            link: "/discrepancy-reason",
            parentId: 27,
          },
        ],
      },
    ],
  },
  {
    id: 32,
    label: "Hotel Directory",
    icon: "bx bx-building",
    link: "/hotel-dashboard",
    isShowWithoutHotel: false,
    includeProjectType: ["guest_xp_app", "settings"],
    subItems: [
      {
        id: 33,
        label: "Editor",
        link: "/design-page",
        parentId: 32,
      },
      {
        id: 34,
        label: "Hotel Info",
        link: "/hotel-directory",
        parentId: 32,
      },
      {
        id: 35,
        label: "Room Info",
        link: "/room-info",
        parentId: 32,
      },
      {
        id: 36,
        label: "NearBy Places",
        link: "/near-by-place",
        parentId: 32,
      },
      {
        id: 37,
        label: "TV Channel",
        link: "/tv-channel",
        parentId: 32,
      },
      {
        id: 38,
        label: "Local Event",
        link: "/local-event",
        parentId: 32,
      },
    ],
  },
  {
    id: 39,
    label: "User Review",
    icon: "bx bx-star",
    link: "/user-review",
    isShowWithoutHotel: false,
    includeProjectType: ["misc"],
  },
  {
    id: 41,
    label: "Room Lock",
    icon: "bx bx-lock-open",
    link: "/room-lock",
    isShowWithoutHotel: false,
    includeProjectType: ["misc"],
    subItems: [
      {
        id: 42,
        label: "Key Log",
        link: "/key-log",
        parentId: 41,
      },
      {
        id: 43,
        label: "Settings",
        parentId: 41,
        subItems: [
          {
            id: 44,
            label: "Gateway List",
            link: "/gateway-list",
            parentId: 43,
          },
          {
            id: 45,
            label: "Staff Group",
            link: "/staff-group",
            parentId: 43,
          },
          {
            id: 46,
            label: "RFID Encoder List",
            link: "/rfid-encoder-list",
            parentId: 43,
          },
        ],
      },
    ],
  },
  {
    id: 47,
    label: "Setting",
    icon: "bx-cog",
    link: "/hotel",
    isShowWithoutHotel: false,
    includeProjectType: ["super_admin", "settings"],
    subItems: [
      {
        id: 48,
        label: "My Hotel",
        link: "/hotel",
        parentId: 47,
        subItems: [
          {
            id: 49,
            label: "Hotel Detail",
            link: "/hotel",
            parentId: 48,
          },
          {
            id: 50,
            label: "Hotel Additional Field",
            link: "/additional-fields",
            parentId: 48,
          },
        ],
      },
      {
        id: 51,
        label: "Account Setup",
        link: "/account-setup",
        parentId: 47,
      },
      {
        id: 52,
        label: "Staff & Permission",
        parentId: 47,
        subItems: [
          {
            id: 53,
            label: "Role",
            link: "/role",
            parentId: 52,
          },
          {
            id: 54,
            label: "Staff",
            link: "/staff",
            parentId: 52,
          },
        ],
      },
      {
        id: 55,
        label: "Email Template",
        link: "/email-templates",
        parentId: 47,
      },
      {
        id: 56,
        label: "Payment Methods",
        link: "/accounts",
        icon: "bx-home-circle",
        parentId: 47,
      },
    ],
  },

  // SUPER ADMIN PANEL MENUS
  {
    id: 40,
    label: "Kiosk Status",
    icon: "bx bx-stats",
    link: "/kiosk-status",
    isShow: true,
    isShowWithoutHotel: false,
    includeProjectType: ["kiosk"],
  },
  {
    id: 57,
    label: "Hotel List",
    icon: "bx bxs-building-house",
    link: "/hotel-list",
    isShow: true,
    isShowWithoutHotel: false,
    isDomainUser: false,
    includeProjectType: ["super_admin", "guest_xp_app"],
    subItems: [
      {
        id: 58,
        label: "Hotel Brands",
        icon: "bx bxs-crown",
        link: "/brand-list",
        parentId: 57,
      },
      {
        id: 59,
        label: "Hotel Themes",
        icon: "bx bxs-collection",
        link: "/theme-list",
        parentId: 57,
      },
    ],
  },
  {
    id: 60,
    label: "IOT Lock",
    icon: "bx bx-lock",
    link: "/gateway",
    isShow: true,
    isShowWithoutHotel: false,
    isDomainUser: false,
    includeProjectType: ["lock"],
    subItems: [
      {
        id: 61,
        label: "RFID Encoder",
        link: "/rfid-encoder",
        parentId: 60,
      },
      {
        id: 62,
        label: "Gateway",
        link: "/gateway",
        parentId: 60,
      },
      {
        id: 63,
        label: "Device Model",
        link: "/device-model",
        parentId: 60,
      },
      {
        id: 64,
        label: "Device",
        link: "/device",
        parentId: 60,
      },
      {
        id: 65,
        label: "Lock Master",
        link: "/hotel-lock-master",
        parentId: 60,
      },
    ],
  },
  {
    id: 66,
    label: "App Feature",
    icon: "bx bx-money",
    link: "/app-feature",
    isShow: true,
    isShowWithoutHotel: false,
    isDomainUser: false,
    includeProjectType: ["guest_xp_app"],
  },
  {
    id: 86,
    label: "PBX Customer List",
    icon: "bx bx-user-check",
    link: "/customer-list",
    isShow: true,
    isShowWithoutHotel: false,
    isDomainUser: true,
    includeProjectType: ["CloudExt PBX"],
  },
  {
    id: 67,
    label: "Domain List",
    icon: "bx bx-globe",
    link: "/domain",
    isShow: true,
    isShowWithoutHotel: false,
    isDomainUser: true,
    includeProjectType: ["CloudExt PBX"],
  },
  {
    id: 68,
    label: "Support Tickets",
    icon: "bx bx-headphone",
    link: "/pbx-ticket",
    isShow: true,
    isShowWithoutHotel: false,
    isDomainUser: true,
    includeProjectType: ["CloudExt PBX"],
  },
  {
    id: 69,
    label: "Wakeup Calls",
    icon: "bx bx-alarm",
    link: "/wakeup-calls",
    isShow: true,
    isShowWithoutHotel: false,
    isDomainUser: true,
    includeProjectType: ["CloudExt PBX"],
  },
  {
    id: 74,
    label: "Setting",
    icon: "bx-cog",
    link: "/pbx-server",
    isShow: true,
    isShowWithoutHotel: false,
    isDomainUser: false,
    includeProjectType: ["CloudExt PBX"],
    subItems: [
      {
        id: 75,
        label: "Server List",
        link: "/pbx-server",
        parentId: 74,
      },
      {
        id: 93,
        label: "Security Group",
        link: "/security-group",
        parentId: 74,
      },
      {
        id: 76,
        label: "Device Profile",
        link: "/device-profile",
        parentId: 74,
      },
      {
        id: 77,
        label: "Ticket Title",
        link: "/pbx-ticket-title",
        parentId: 74,
      },
      {
        id: 87,
        label: "Server Health",
        link: "/server-health",
        parentId: 74,
      },
      {
        id: 88,
        label: "Notification Alert",
        link: "/notification-alert",
        parentId: 74,
      },
    ],
  },
  {
    id: 79,
    label: "Hotel Admin",
    icon: "bx bx-user",
    link: "/hotel-admin-user",
    isDomainUser: false,
    isShow: true,
    isShowWithoutHotel: false,
    includeProjectType: ["super_admin", "CloudExt PBX"],
    subItems: [
      {
        id: 89,
        label: "Reseller User",
        link: "/reseller-user",
        parentId: 79,
      },
      {
        id: 80,
        label: "Support Admin",
        link: "/support-user",
        parentId: 79,
      },
    ],
  },
  {
    id: 81,
    label: "Hotel List",
    icon: "bx bx-globe",
    link: "/ai-bot/hotel-list",
    isShow: true,
    isShowWithoutHotel: false,
    isDomainUser: true,
    includeProjectType: ["CloudExt PBX"],
  },
  {
    id: 90,
    label: "CRM Accounts",
    icon: "bx bx-receipt",
    link: "/invoicely",
    isShow: true,
    isShowWithoutHotel: false,
    isDomainUser: true,
    includeProjectType: ["CloudExt PBX"],
    subItems: [
      {
        id: 91,
        label: "CRM Admin",
        link: "/crm-admin",
        parentId: 90,
      },
    ],
  },
  {
    id: 92,
    label: "ID Scan",
    icon: "bx bx-fullscreen",
    link: "/id-scan-desktop",
    isShow: true,
    isShowWithoutHotel: false,
    isDomainUser: true,
    includeProjectType: ["ID Scan Desktop"],
  },
  {
    id: 93,
    label: "Kiosk Meta",
    icon: "bx bx-card",
    link: "/kiosk-meta",
    isShow: true,
    isShowWithoutHotel: false,
    isDomainUser: true,
    includeProjectType: ["super_admin", 'ID Scan Desktop"'],
    subItems: [
      {
        id: 94,
        label: "Kiosk Meta Tag",
        link: "/kiosk-meta-tag",
        parentId: 93,
      },
    ],
  },
];

// last id is 95
